import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';

import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import ChequeNewEditForm from '../cheque-new-edit-form';

export default function ChequeCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a new cheque"
        links={[
          {
            name: 'Cheque',
            href: paths.dashboard.cheque.root(),
          },
          { name: 'Create a new cheque' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <ChequeNewEditForm />
    </Container>
  );
}
